var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGalleryIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7143 0.962891H2.28571C1.02335 0.962891 0 1.92228 0 3.10575V14.8915C0 16.0749 1.02335 17.0343 2.28571 17.0343H13.7143C14.9767 17.0343 16 16.0749 16 14.8915V3.10575C16 1.92228 14.9767 0.962891 13.7143 0.962891Z",
    fill: "#DDEBFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2851 8.17064C12.1769 8.07533 12.0333 8.02326 11.8849 8.02546C11.7364 8.02766 11.5947 8.08395 11.4897 8.18243L9.0257 10.493C8.91858 10.5934 8.8584 10.7297 8.8584 10.8717C8.8584 11.0138 8.91858 11.15 9.0257 11.2505L14.8674 16.7287C15.2108 16.5414 15.496 16.2731 15.6946 15.9504C15.8932 15.6278 15.9983 15.2621 15.9994 14.8896V11.4433L12.2851 8.17064Z",
    fill: "#C37EFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.71429 7.92718C10.6611 7.92718 11.4286 7.20763 11.4286 6.32003C11.4286 5.43243 10.6611 4.71289 9.71429 4.71289C8.76751 4.71289 8 5.43243 8 6.32003C8 7.20763 8.76751 7.92718 9.71429 7.92718Z",
    fill: "#AC53F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.68971 7.55111C6.58054 7.45432 6.43598 7.40039 6.28571 7.40039C6.13545 7.40039 5.99089 7.45432 5.88171 7.55111L0 13.0652V14.8941C0 15.4625 0.240816 16.0075 0.66947 16.4094C1.09812 16.8112 1.6795 17.037 2.28571 17.037H13.7143C14.1116 17.0359 14.5017 16.9374 14.8459 16.7512C15.19 16.5651 15.4762 16.2977 15.676 15.9758L6.68971 7.55111Z",
    fill: "#AC53F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalleryIcon);
export default __webpack_public_path__ + "static/media/GalleryIcon.4df7468eb0859997fead799eea13a50b.svg";
export { ForwardRef as ReactComponent };